function getAuthHeaders() {
  return {
    "Content-Type": "application/json",
  };
}

async function handleResponse(response, fallbackMessage) {
  if (!response.ok) {
    let errorMessage = fallbackMessage;

    try {
      const errorData = await response.json();
      if (errorData?.detail) {
        errorMessage = errorData.detail;
      } else if (errorData?.message) {
        errorMessage = errorData.message;
      }
    } catch (_) {}

    throw new Error(errorMessage);
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
}

export async function submitSessionFeedback(payload) {
  const response = await fetch("/py/feedback/submit", {
    method: "POST",
    credentials: "include",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload)
  });
  return handleResponse(response, "Failed to store Feedback Form data.")
}